import { render, staticRenderFns } from "./LoadPayPageComponent.vue?vue&type=template&id=2f0b414f"
import script from "./LoadPayPageComponent.vue?vue&type=script&lang=js"
export * from "./LoadPayPageComponent.vue?vue&type=script&lang=js"
import style0 from "./LoadPayPageComponent.vue?vue&type=style&index=0&id=2f0b414f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports